import React, { FC, useRef } from 'react';
import * as S from 'components/Forms/Forms.style';
import { BASE_CONFIG } from 'pages/Game/Game';
import points from 'assets/points.svg';
import { Button, ButtonVariant } from 'components/Button/Button';
import { GameType, useGame } from '../../../context/GameContext';
import { usePlayers } from '../../../context/PlayerContext';
import fanfareSuccess from '../../../assets/audio/fanfare-success.mp3';

interface ScoreUpdateFormProps {
  openPointsDialog: () => void;
}

export const ScoreUpdateForm: FC<ScoreUpdateFormProps> = ({
  openPointsDialog,
}) => {
  const fanfareSuccessRef = useRef<HTMLAudioElement | null>(null);
  const { updateClassicScore, updateDartsScore } = usePlayers();
  const { isGameFinished, isLastRound, gameSettings } = useGame();

  const handleUpdateScore = (parsedPoints: number) => {
    gameSettings.type === GameType.SUM_OF_POINTS
      ? updateClassicScore(parsedPoints)
      : updateDartsScore(parsedPoints);
  };

  return !isGameFinished ? (
    <>
      <audio ref={fanfareSuccessRef} src={fanfareSuccess} />
      <S.Container>
        <h3>
          {gameSettings.type === GameType.SUM_OF_POINTS ? (
            'Points / Body'
          ) : (
            <div
              style={{
                display: 'inline-flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <div>Points / Body</div>
              <div>{`Cíl - ${gameSettings.target}`}</div>
            </div>
          )}
        </h3>
        <S.PointsContainer>
          {BASE_CONFIG.points.map((point, index) => {
            const parsedPoints =
              isLastRound && gameSettings.doublePointsStatus
                ? point * 2
                : point;
            const isLastItem = BASE_CONFIG.points.length - 1 === index;

            return (
              <S.PointItem key={`point-0${point}`} isHalf={isLastItem}>
                <Button
                  key={point}
                  type="button"
                  variant={ButtonVariant.SCORE}
                  disabled={isGameFinished}
                  onClick={() => handleUpdateScore(parsedPoints)}
                  style={{ fontWeight: 'bold' }}
                >
                  {point}
                </Button>
              </S.PointItem>
            );
          })}
          <S.PointItem isHalf={true}>
            <Button
              onClick={() => {
                if (!isGameFinished) {
                  openPointsDialog();
                }
              }}
              variant={ButtonVariant.SCORE}
              style={{
                gap: 8,
                borderBottomRightRadius: 10,
              }}
            >
              <img src={points} alt="points" />
              <div style={{ fontSize: 16 }}>Jiný počet</div>
            </Button>
          </S.PointItem>
        </S.PointsContainer>
      </S.Container>
    </>
  ) : null;
};
